import { render, staticRenderFns } from "./ListReviewCustomer.vue?vue&type=template&id=345e3b0c&scoped=true&"
import script from "./ListReviewCustomer.vue?vue&type=script&lang=js&"
export * from "./ListReviewCustomer.vue?vue&type=script&lang=js&"
import style0 from "../SalesForce.scss?vue&type=style&index=0&id=345e3b0c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "345e3b0c",
  null
  
)

export default component.exports